import { API_ENDPOINTS } from "../api-endpoints";
import { HttpClient } from "../http-client";

export const FileUpload = {
  upload: (body: FormData) => {
    const fileHeader = {
      "Content-Type": "multipart/form-data",
    };
    return HttpClient.post(API_ENDPOINTS.S3, body, { headers: fileHeader });
  },
  multipleUpload: (body: FormData[]) => {
    const fileHeader = {
      "Content-Type": "multipart/form-data",
    };
    return HttpClient.post(`${API_ENDPOINTS.S3}/upload-multiple-files`, body, {
      headers: fileHeader,
    });
  },
};
